import React from 'react'
import {Flex, Text} from '../../vanilla'
import {useOrderStore, useBasketStore} from '../../store/hooks/useStore'
import {FormattedNumber} from 'react-intl'

interface ShoppingTotalProps {
  inDrawer?: boolean
  excludeSmallBasketCharge?: boolean
}

export const ShoppingTotal = ({inDrawer, excludeSmallBasketCharge}: ShoppingTotalProps) => {
  const {orderTotal} = useOrderStore()
  const {basket, basketSmallBasketCharge} = useBasketStore()

  let displayTotal = orderTotal

  // Exclude the small basket charge if needed. Due to how the basket is reset after an edit
  // only deduct if the basket is not empty.
  if (orderTotal && excludeSmallBasketCharge && basketSmallBasketCharge) {
    displayTotal = orderTotal - basketSmallBasketCharge
  }

  return (
    <Flex flexDirection="column" align="flex-end">
      <Text
        variant="unstyled"
        fontSize={inDrawer ? 'md' : 'xs'}
        fontWeight={inDrawer ? 'normal' : ['normal', 'medium']}
        as="span"
        lineHeight="none"
        data-test-selector={inDrawer ? 'cart-drawer-basket-total' : 'basket-total-amount'}
      >
        {displayTotal ? (
          <FormattedNumber style="currency" currency={basket?.currency} value={displayTotal} />
        ) : (
          '£0.00'
        )}
      </Text>
      <Text
        color="textMuted"
        variant="unstyled"
        fontSize="xxs"
        fontWeight="normal"
        lineHeight="none"
        data-test-selector="inc-fees-text"
      >
        inc. fees
      </Text>
    </Flex>
  )
}
